<script>
import ListingModel from "@/views/Edms/TemplateApplication/Components/ListingModel.vue";
import {ref} from "vue";

export default {
    name: "ModuleTemplateApplications",
    components: {ListingModel},
    props: {
        module: String,
    },
    setup() {
        const sheet = ref(true);

        return {sheet};
    }
}
</script>

<template>
    <v-bottom-sheet
        v-model="sheet"
        inset
        persistent
    >
        <ListingModel :module="module"/>
    </v-bottom-sheet>
</template>